import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Colors from "./../../Global/colors";
import "../workflow/workflow.css";
import "../../index.css";
import useStyles from "./workflowStyle";
import Popover from "@material-ui/core/Popover";
import { ListItemIcon } from "@material-ui/core";
import {useTranslation} from "react-i18next";
import uuid from "react-uuid";
import swal from "sweetalert"


const ColorPopper = (props) => {
  const {t} = useTranslation();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [pickedColor, setPickColor] = React.useState(props.editRole ? props.currentColor : "#fe8500");
  React.useState(() => {
    props.setColor(props.editRole ? props.currentColor : "#fe8500");
  });
  const [color, setColor] = React.useState([
    { id: "1", color: "#fe8500" },
    { id: "2", color: "#9c6d1e" },
    { id: "3", color: "#c60022" },
    { id: "4", color: "#ffb000" },
    { id: "5", color: "#81b532" },
    { id: "6", color: "#13855f" },
    { id: "7", color: "#00b6cb" },
    { id: "8", color: "#648fff" },
    { id: "9", color: "#0044a3" },
    { id: "10", color: "#81599f" },
    { id: "11", color: "#c22dd5" },
    { id: "12", color: "#707070" },
    { id: "13", color: "#8dd3c7" },
    { id: "14", color: "#01735a" },
    { id: "15", color: "#0d5f8a" },
    { id: "16", color: "#9bccfd" },
    { id: "17", color: "#dad870" },
    { id: "18", color: "#e7298a" },
    { id: "19", color: "#ff5c4d" },
    { id: "20", color: "#4120a9" },
  ]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const closePicker = (color) => {
    setPickColor(color);
    props.setColor(color);
    handleClose();
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div style={{ flexDirection: "row", display: "flex" }}>
      <div>
        <Button
          aria-describedby={id}
          className="addBtn"
          variant="contained"
          onClick={handleClick}
          style={{backgroundColor:Colors.globalColor8}}
        >
          {t("Pick Color")}
        </Button>
        <Popover
          style={{ zIndex: 3 }}
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          {
            <div className="divGridLayout">
              {color.map((c) => {
                return (
                  <ListItemIcon
                    onClick={() => {
                      closePicker(c.color);
                    }}
                  >
                    <div
                      className={classes.colorStyle}
                      style={{ backgroundColor: c.color }}
                    />
                  </ListItemIcon>
                );
              })}
            </div>
          }
        </Popover>
      </div>
      <div
        style={{
          marginLeft: 20,
          width: 40,
          height: 40,
          borderRadius: 80 / 2,
          marginBottom: 10,
          backgroundColor: pickedColor,
        }}
      />
    </div>
  );
};


export default function FormDialog(props) {
  let {t} = useTranslation();
  const classes = useStyles();
  const [open, setOpen] = React.useState(props.modal);
  const [pickedColor, setPickColor] = React.useState("");
  const [title, setTitle] = React.useState(props?.currentRole?.title);
  const userPickColor = (color) => {
    setPickColor(color);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    props.closeModal();
  };
  const handleCreate = async () => {

    if(title == ""){
      swal(t("Error"), t("Please Enter Role Title"), "error");
      return;
    }
    var hierarchy = {
      title: title,
      color: pickedColor,
    };
    await props.addNewHierarchy(hierarchy);
    await handleClose();
  };

  const handleEdit = async () => {
    var hierarchy = {
      hierarchy_id : props.currentRole.id,
      title: title,
      color: pickedColor,
    };
    await props.editHierarchy(hierarchy);
    await handleClose();
  };

  console.log("PROPS", props)
  useEffect(() => {
    if (props.modal != open) setOpen(props.modal); 
  });

  useEffect(() => {
    if(props.editRole){
      setTitle(props.currentRole.title);
      // setPickColor(props.currentRole.color)
    }else{
      setTitle("");
      setPickColor("")
    }
  },[props.currentRole.title,props.editRole]);


  const handleChage = (event) => {
    setTitle(event.target.value);
  };
  return <div>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          {props.editRole ? <p className="label2" style={{ marginBottom: 5, fontSize: 16, marginTop: 7, color: Colors.globalColor8, textTransform: "uppercase" }}>
            {t("Edit Hierarchy")}
          </p>: <p className="label2" style={{ marginBottom: 5, fontSize: 16, marginTop: 7, color: Colors.globalColor8, textTransform: "uppercase" }}>
            {t("New Hierarchy")}
          </p>}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("To create new hierarchy level for the information flow of your organization, please enter details below to complete the process")}
          </DialogContentText>
          <TextField autoFocus margin="dense" id="name" label={t("Title")} value={title} fullWidth autoComplete="off" onChange={handleChage} className={["customField", { className: classes.textBoxStyle }]} InputProps={{ className: classes.textBoxStyle }} />          
          <ColorPopper setColor={userPickColor} editRole={props.editRole} currentColor={props.currentRole.color}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>handleClose()} className="cancelBtn" color="primary">
              {t("Cancel")}
          </Button>
          {props.editRole ? <Button
          className="addBtn"
          variant="contained"
          onClick={()=>handleEdit()}
          style={{backgroundColor:Colors.globalColor8}}
        >
          {t("Update")}
        </Button> : <Button
          className="addBtn"
          variant="contained"
          onClick={()=>handleCreate()}
          style={{backgroundColor:Colors.globalColor8}}
        >
          {t("Create")}
        </Button>} 

        </DialogActions>
      </Dialog>
    </div>;
}
